const areDatesEqual = (date_1?: Date, date_2?: Date): boolean => {
  if (!date_1 || !date_2) return false;

  return (
    date_1.getFullYear() === date_2.getFullYear() &&
    date_1.getMonth() === date_2.getMonth() &&
    date_1.getDate() === date_2.getDate()
  );
};

const commissionsInactiveTableHelper = {
  areDatesEqual,
};

export default commissionsInactiveTableHelper;
